import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './Planner'; // O arquivo principal será o Planner.js
import './index.css';

// Estilos globais simples para resetar margens
const style = document.createElement('style');
style.innerHTML = `
  body { margin: 0; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif; -webkit-font-smoothing: antialiased; }
  * { box-sizing: border-box; }
  /* Tailwind Import via CDN no index.html resolve o resto */
`;
document.head.appendChild(style);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);